import React from "react";
import {
  Flag, Utensils, Footprints, Coffee, Clapperboard, Truck, Package,
  Star, AlertTriangle, Target, Moon, Sun, PartyPopper, Camera, Car,
} from "lucide-react";

// Slug → lucide component. "flag-checkered" is hand-drawn to match the
// backend PDF glyph (see /app/backend/banner_icons.py).
const MAP = {
  "flag": Flag,
  "utensils": Utensils,
  "footprints": Footprints,
  "coffee": Coffee,
  "clapperboard": Clapperboard,
  "truck": Truck,
  "package": Package,
  "star": Star,
  "alert-triangle": AlertTriangle,
  "target": Target,
  "moon": Moon,
  "sun": Sun,
  "party-popper": PartyPopper,
  "camera": Camera,
  "car": Car,
};

// Slug → human label for the picker.
export const BANNER_ICON_OPTIONS = [
  { slug: "flag", label: "Flag" },
  { slug: "flag-checkered", label: "Checkered Flag" },
  { slug: "utensils", label: "Fork & Knife" },
  { slug: "footprints", label: "Walking" },
  { slug: "coffee", label: "Coffee" },
  { slug: "clapperboard", label: "Clapperboard" },
  { slug: "truck", label: "Truck" },
  { slug: "car", label: "Car" },
  { slug: "package", label: "Package / Wrap" },
  { slug: "camera", label: "Camera" },
  { slug: "star", label: "Star" },
  { slug: "alert-triangle", label: "Warning" },
  { slug: "target", label: "Target" },
  { slug: "moon", label: "Moon" },
  { slug: "sun", label: "Sun" },
  { slug: "party-popper", label: "Party" },
];

function CheckeredFlag({ size = 14, color = "currentColor", strokeWidth = 2.2 }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none"
         stroke={color} strokeWidth={strokeWidth}
         strokeLinecap="round" strokeLinejoin="round" aria-hidden>
      <path d="M4 15s1-1 4-1 5 2 8 2 4-1 4-1V3s-1 1-4 1-5-2-8-2-4 1-4 1z"/>
      <line x1="4" y1="22" x2="4" y2="15"/>
      <rect x="6"  y="4"  width="4" height="4" fill={color} stroke="none"/>
      <rect x="14" y="4"  width="4" height="4" fill={color} stroke="none"/>
      <rect x="10" y="8"  width="4" height="4" fill={color} stroke="none"/>
      <rect x="6"  y="12" width="4" height="4" fill={color} stroke="none"/>
      <rect x="14" y="12" width="4" height="4" fill={color} stroke="none"/>
    </svg>
  );
}

/**
 * Render the icon for a banner. Always black-and-white.
 * `slug` is a value from BANNER_ICON_OPTIONS. Unknown slugs render nothing
 * (or the raw glyph if it looks like a legacy emoji).
 */
export default function BannerIcon({ slug, size = 14, color = "currentColor", className = "" }) {
  if (!slug) return null;
  if (slug === "flag-checkered") {
    return <CheckeredFlag size={size} color={color} />;
  }
  const Ico = MAP[slug];
  if (Ico) return <Ico size={size} color={color} className={className} strokeWidth={2.2} />;
  // Legacy fallback: raw emoji string, force text presentation
  return <span aria-hidden style={{ fontFamily: "Arial, sans-serif" }}>{slug}{"\uFE0E"}</span>;
}
